import React, { useEffect, useState } from "react";
import axios from "axios";
import { AvatarLabelGroup, Button, SearchLg, TextInput } from "@opendate-app/setlist";

import SampleDataContainer from "./SampleDataContainer";
import { useBroadcastEditContext } from "./BroadcastEditContainer";
import { toastError } from "../../../shared/toastHelper";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 16,
};

const headerStyle = {
  color: "var(--sl-text-primary)",
  fontSize: 14,
  fontWeight: 600,
};

const resultsStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  border: "1px solid var(--sl-border-secondary)",
  borderRadius: "var(--sl-radius-md)",
  padding: 4,
};

const getInitials = (firstName, lastName) => `${firstName[0]}${lastName[0]}`.toUpperCase();

const SampleDataPicker = () => {
  const {
    team,
    csrfToken,
    setSampleFanId,
    sampleData,
  } = useBroadcastEditContext();

  const [inputValue, setInputValue] = useState("");
  const [results, setResults] = useState([]);

  const fan = sampleData.fan || {};
  const initials = fan.first_name && fan.last_name ? getInitials(fan.first_name, fan.last_name) : "";

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (!inputValue) {
        setResults([]);
        return;
      }

      axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
      axios.get(`/teams/${team.id}/fans/email_search`, { params: { name: inputValue } })
        .then((response) => setResults(response.data))
        .catch(() => {
          setResults([]);
          toastError("Could not search fans, please try again");
        });
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [inputValue]);

  const pickFan = (fanId) => {
    setResults([]);
    setInputValue("");
    setSampleFanId(fanId);
  };

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>Sample data</div>
      <TextInput
        size="sm"
        aria-label="Find a fan by email address"
        placeholder="Find by email address…"
        leadingIcon={SearchLg}
        value={inputValue}
        onChange={(event) => setInputValue(event.target.value)}
      />
      {results.length > 0 && (
        <div style={resultsStyle}>
          {results.map((item) => (
            <Button key={item.id} variant="tertiary" size="sm" onClick={() => pickFan(item.id)}>
              {item.name}
            </Button>
          ))}
        </div>
      )}
      {fan.email && (
        <AvatarLabelGroup
          size="md"
          name={`${fan.first_name || ""} ${fan.last_name || ""}`.trim() || fan.email}
          supportingText={fan.email}
          initials={initials}
          alt={fan.email}
        />
      )}
      <SampleDataContainer />
    </div>
  );
};

export default SampleDataPicker;
